import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  /* route API for professional specializations */
  resourcePath: '/v1/professional/specializations'
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/resources/index.js